import { useSetAtom } from 'jotai';
import { WidgetType } from 'modules/dashboard/types/widgets/widget.enums';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { listWidgetDataAtom } from 'stores/dashboard-store/dashboard-store';

export type WidgetActions = {
  [WidgetType.table]: () => void;
  [WidgetType.personalDetails]: () => void;
  [WidgetType.bankAccounts]: () => void;
  [WidgetType.list]: () => void;
};

export const useWidgetActions = (): WidgetActions => {
  const navigate = useNavigate();
  const setListWidgetData = useSetAtom(listWidgetDataAtom);
  const handleClientMaintenanceNavigation = useCallback(() => {
    //Todo: Update route when client maintenance page is ready
    navigate('/dashboard');
  }, [navigate]);

  return {
    [WidgetType.table]: () => {
      //Todo: Implement table widget action
    },
    [WidgetType.personalDetails]: handleClientMaintenanceNavigation,
    [WidgetType.bankAccounts]: handleClientMaintenanceNavigation,
    [WidgetType.list]: useCallback(() => {
      setListWidgetData((prevList) => [...prevList, `Item ${prevList.length + 1}`]);
    }, [setListWidgetData])
  };
};
